import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import MaterialTable from "material-table";
import { withStyles } from "@material-ui/core/styles";
import withWidth from "@material-ui/core/withWidth";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import AddOutlinedIcon from "@material-ui/icons/AddOutlined";
import DeleteOutlinedIcon from "@material-ui/icons/DeleteOutlined";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DoneOutlinedIcon from "@material-ui/icons/DoneOutlined";
import ClearOutlinedIcon from "@material-ui/icons/ClearOutlined";
import SearchOutlinedIcon from "@material-ui/icons/SearchOutlined";
import NavigateNextOutlinedIcon from "@material-ui/icons/NavigateNextOutlined";
import NavigateBeforeOutlinedIcon from "@material-ui/icons/NavigateBeforeOutlined";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import LastPageIcon from "@material-ui/icons/LastPage";
import { Typography } from "@material-ui/core";
import AttachFileOutlinedIcon from "@material-ui/icons/AttachFileOutlined";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";
import { getStudentVotes } from "../firebaseApi";
const styles = (theme) => ({});

function StudentPollHistory(props) {
  let { course } = props;
  let { studentID } = props;
  let [sessions, setSessions] = useState([]);
  let [votes, setVotes] = useState([]);
  let { tableData } = props;

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={props.open}
      onClose={() => {
        props.openCtl(false);
      }}
    >
      <DialogTitle>{"Poll History for " + props.course.courseName}</DialogTitle>

      <DialogContent>
        <MaterialTable
          title={"Polls for " + course.courseName}
          columns={[
            { title: "Date", field: "date", editable: "never", sorting: false },
            {
              title: "Polls",
              field: "polls",
              editable: "never",
              sorting: false,
            },
            {
              title: "Votes",
              field: "votes",
              editable: "never",
              sorting: false,
            },
          ]}
          icons={{
            Add: AddOutlinedIcon,
            Delete: DeleteOutlinedIcon,
            Edit: EditOutlinedIcon,
            Check: DoneOutlinedIcon,
            Clear: ClearOutlinedIcon,
            Search: SearchOutlinedIcon,
            FirstPage: FirstPageIcon,
            LastPage: LastPageIcon,
            NextPage: NavigateNextOutlinedIcon,
            PreviousPage: NavigateBeforeOutlinedIcon,
            ResetSearch: ClearOutlinedIcon,
          }}
          data={tableData === null ? [] : tableData}
        />
      </DialogContent>

      <DialogActions>
        <Button
          color="primary"
          onClick={() => {
            //console.log(tableData)
            props.openCtl(false);
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

const mapStateToProps = (state) => {
  return state;
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withRouter(
    withStyles(styles, { withTheme: true })(withWidth()(StudentPollHistory))
  )
);
